<template>
  <div class="home-zgyw" v-loading="loading">
    <!-- <p class="color-title">组工业务&nbsp;&nbsp;横向<span>致远</span>&nbsp;&nbsp;垂直<span>致深</span></p> -->
    <p class="hy-title">产品体系</p>
    <div class="zg-system">
      <div class="zg-system__tabs" role="tablist" aria-label="组工业务系统分类">
        <p
          v-for="(tab, index) in tabs"
          :key="tab.id"
          type="button"
          role="tab"
          class="zg-system__tab"
          :class="{ 'is-active': activeTabIndex === index }"
          :aria-selected="activeTabIndex === index"
          @click="handleSystemTabClick(index)"
        >
          {{ tab.name }}
        </p>
      </div>
      <div v-if="!loading && !currentProducts.length" class="system-content">
        <p class="system-state">该分类暂无产品</p>
      </div>
      <div v-else-if="currentProduct" class="system-content">
        <div class="system-model">
          <p
            v-for="(item, index) in currentProducts"
            :key="item.id"
            class="system-model__item"
            :class="{ active: activeModelIndex === index }"
            @click="activeModelIndex = index"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="system-model-desc">
          <p class="system-model-desc__title">
            {{ currentProduct.name }}
          </p>
          <p class="system-model-desc__desc">
            {{ productDesc(currentProduct) }}
          </p>
          <p class="system-model-desc__more" @click="openProduct(currentProduct)">
            查看更多&nbsp;&nbsp;<i class="el-icon-right"></i>
          </p>
        </div>
        <div class="system-model-img" :style="currentProductImgStyle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import api, { getMediaUrl, getGalleryUrls } from "@/api";
import { htmlToPlainExcerpt } from "@/utils/richContent";

const CATEGORY_TABS = [
  { id: "gwy", name: "公务员类" },
  { id: "gb", name: "干部类" },
  { id: "pad", name: "平板类" },
  { id: "AI", name: "AI应用" },
  { id: "other", name: "其他" },
];

const KNOWN_SLUGS = new Map(CATEGORY_TABS.map((tab) => [tab.id.toLowerCase(), tab.id]));

function firstMediaUrl(media) {
  if (!media) return "";
  if (typeof media === "string") return media;
  if (media.url) return getMediaUrl(media);
  const data = media.data;
  if (!data) return "";
  const list = Array.isArray(data) ? data : [data];
  const first = list[0];
  if (!first) return "";
  return getMediaUrl(first.attributes || first);
}

export default {
  name: "HomeZgyw",
  data() {
    return {
      list: [],
      loading: false,
      activeTabIndex: 0,
      activeModelIndex: 0,
    };
  },
  computed: {
    tabs() {
      return CATEGORY_TABS;
    },
    currentTab() {
      return this.tabs[this.activeTabIndex] || this.tabs[0];
    },
    currentProducts() {
      const tabId = this.currentTab && this.currentTab.id;
      return this.list.filter((p) => this.productTabSlug(p) === tabId);
    },
    currentProduct() {
      return (
        this.currentProducts[this.activeModelIndex] || this.currentProducts[0] || null
      );
    },
    currentProductImgStyle() {
      const src = this.cardCover(this.currentProduct);
      if (!src) return {};
      return {
        backgroundImage: `url(${JSON.stringify(src)})`,
      };
    },
  },
  async created() {
    this.loading = true;
    try {
      this.list = [...((await api.getProducts()) || [])];
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    handleSystemTabClick(index) {
      this.activeTabIndex = index;
      this.activeModelIndex = 0;
    },
    productCategory(product) {
      const raw = product && product.category;
      if (!raw) return null;
      const data = raw.data !== undefined ? raw.data : raw;
      if (!data) return null;
      const node = Array.isArray(data) ? data[0] : data;
      if (!node) return null;
      const attrs = node.attributes || node;
      return {
        id: node.id != null ? node.id : attrs.id,
        name: attrs.name,
        slug: attrs.slug || "",
      };
    },
    productTabSlug(product) {
      const cat = this.productCategory(product);
      const slug = String((cat && cat.slug) || "")
        .trim()
        .toLowerCase();
      return KNOWN_SLUGS.get(slug) || "other";
    },
    cardCover(product) {
      if (!product) return "";
      if (product.coverSrc) return product.coverSrc;
      return (
        firstMediaUrl(product.coverImage) || getGalleryUrls(product.gallery)[0] || ""
      );
    },
    productDesc(product) {
      if (!product) return "";
      return (
        htmlToPlainExcerpt(product.subTitle || product.summary || "", 160) ||
        "该产品提供组织人事业务能力支撑，满足多场景综合管理需求。"
      );
    },
    openProduct(product) {
      if (!product || product.id == null) return;
      this.$router.push(`/products/${product.id}`);
    },
  },
};
</script>

<style lang="less">
@zg-tab-active: rgba(244, 54, 8, 1);
@zg-tab-text: rgba(56, 73, 89, 1);

.home-zgyw {
  position: relative;
  height: 725px;
  background-image: url("@/assets/images/zgyw-bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 64px;

  .zg-system {
    margin-top: 48px;
    padding: 0 24px 24px;
  }

  .zg-system__tabs {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 40px;
  }

  .zg-system__tab {
    height: 50px;
    line-height: 46px;
    margin: 0 5px;
    padding: 0 30px;
    font-size: 20px;
    font-weight: 500;
    color: rgba(52, 52, 52, 1);
    border-radius: 87px;
    background: rgba(255, 255, 255, 0.55);
    border: 1px solid rgba(229, 231, 239, 1);
    cursor: pointer;
    &:hover {
      box-shadow: 0 2px 8px rgba(56, 73, 89, 0.08);
    }

    &.is-active {
      color: @zg-tab-active;
      border-color: @zg-tab-active;
    }
  }
  .system-content {
    position: relative;
    height: 455px;
    display: flex;
    align-items: center;
    margin: 0 70px;
    padding-right: 20px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
  }
  .system-state {
    width: 100%;
    text-align: center;
    color: #94a3b8;
    font-size: 16px;
  }

  .system-model {
    box-sizing: border-box;
    width: 220px;
    height: 100%;
    padding: 10px;
    overflow-y: auto;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
  }

  .system-model__item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    font-size: 15px;
    color: #4a4a4a;
    // padding: 0 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    &::after {
      content: "";
      position: absolute;
      left: 16px;
      bottom: 0;
      width: 0;
      height: 1px;
      background: @zg-tab-active;
      opacity: 0.8;
      z-index: 1;
      transition: all 0.3s ease;
    }
    &.active {
      color: @zg-tab-active;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 242, 242, 0.8) 100%
      );
      &::after {
        width: calc(100% - 40px);
      }
    }
  }
  .system-model-desc {
    flex: 1;
    height: 100%;
    padding: 20px;
    overflow: hidden;
    background-image: url("@/assets/images/cro.png");
    background-repeat: no-repeat;
    background-position: right -41px bottom 14px;
    .system-model-desc__title {
      height: 30px;
      line-height: 30px;
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: 700;
      color: rgba(35, 35, 35, 1);
    }
    .system-model-desc__desc {
      // height: 120px;
      max-height: 305px;
      text-indent: 2em;
      display: -webkit-box;
      -webkit-line-clamp: 11;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      color: rgba(51, 51, 51, 1);
      font-size: 20px;
      line-height: 28px;
    }
    .system-model-desc__more {
      margin-top: 20px;
      width: 154px;
      height: 44px;
      line-height: 44px;
      font-size: 18px;
      color: white;
      text-align: center;
      background-image: url("@/assets/images/view-detial-bg.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 172px 62px;
      cursor: pointer;
    }
  }

  .system-model-img {
    width: 930px;
    height: 416px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    background-image: url("@/assets/images/default.png");
    background-size: 100%;
  }
}
</style>
